import React from "react";
import A1 from "../../assets/Images/marketing/swiper-image/a1.png";
import B1 from "../../assets/Images/marketing/swiper-image/b1.png";
import C1 from "../../assets/Images/marketing/swiper-image/c1.png";
import D1 from "../../assets/Images/marketing/swiper-image/d1.png";
import E1 from "../../assets/Images/marketing/swiper-image/e1.png";
import F1 from "../../assets/Images/marketing/swiper-image/f1.png";
import G1 from "../../assets/Images/marketing/swiper-image/g1.png";
import H1 from "../../assets/Images/marketing/swiper-image/h1.png";
import I1 from "../../assets/Images/marketing/swiper-image/i1.png";
import J1 from "../../assets/Images/marketing/swiper-image/j1.png";
import K1 from "../../assets/Images/marketing/swiper-image/k1.png";

import A2 from "../../assets/Images/marketing/swiper-image/a2.png";
import B2 from "../../assets/Images/marketing/swiper-image/b2.png";
import C2 from "../../assets/Images/marketing/swiper-image/c2.png";
import D2 from "../../assets/Images/marketing/swiper-image/d2.png";
import E2 from "../../assets/Images/marketing/swiper-image/e2.png";
import F2 from "../../assets/Images/marketing/swiper-image/f2.png";
import G2 from "../../assets/Images/marketing/swiper-image/g2.png";
import H2 from "../../assets/Images/marketing/swiper-image/h2.png";
import I2 from "../../assets/Images/marketing/swiper-image/i2.png";
import J2 from "../../assets/Images/marketing/swiper-image/j2.png";
import K2 from "../../assets/Images/marketing/swiper-image/k2.png";

function ImageSlide() {
  const firstRowImages = [A1, B1, C1, D1, E1, F1, G1, H1, I1, J1, K1];
  const secondRowImages = [K2, J2, I2, H2, G2, F2, E2, D2, C2, B2, A2];

  // Duplicate images for seamless looping
  const duplicatedFirstRow = [...firstRowImages, ...firstRowImages];
  const duplicatedSecondRow = [...secondRowImages, ...secondRowImages];

  return (
    <div className="slider-container">
      {/* First Row (Left to Right) */}
      <div className="slider-row row-1">
        <div className="slider-track">
          {duplicatedFirstRow.map((img, i) => (
            <div className="slider-item" key={`first-${i}`}>
              <img
                src={img}
                alt={`Client ${(i % firstRowImages.length) + 1}`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Second Row (Right to Left) */}
      <div className="slider-row row-2">
        <div className="slider-track">
          {duplicatedSecondRow.map((img, i) => (
            <div className="slider-item" key={`second-${i}`}>
              <img
                src={img}
                alt={`Client ${(i % secondRowImages.length) + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ImageSlide;
